import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DialogService, CoreService, SpinnerService, DataService, SaveDataRequest, VerticalNavigationSettings, SaveFormEvent, FormNavigationService, ElementType, DialogResult, Option } from 'dspx-core';
import { Subscription, bufferTime, filter, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, OPTION_SETS, PAGE_NUMBERS, POP_UP_CODES, POP_UP_HEADER, POP_UP_TEXTS, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { ConcessionsApplicationBaseComponent } from '../concessions-application-base-component/concessions-application-base-component';
import { Guid } from 'guid-typescript';
import * as _ from 'lodash';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-concessions-application-non-mains-water',
  templateUrl: './concessions-application-non-mains-water.component.html',
  styleUrls: ['./concessions-application-non-mains-water.component.scss']
})
export class ConcessionsApplicationNonMainsWaterComponent extends ConcessionsApplicationBaseComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  private _previousTab: number = 1;
  private _previousPage: number = 1;
  private _currentTab: number = 1;
  private _currentPage: number = 1;

  templateId: number = TEMPLATES.concessionsApplicationNonMainsWater;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  primaryAddressIsManual: boolean = false;
  activeApplications: any;
  concessionsPaymentRules: any;
  amountPaidByApplicationYear: any;
  previousInvoiceNumbers: any;
  previousApplications: any;
  isApplicantAssociated: boolean = false;
  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private viewportScroller: ViewportScroller
  ) {
    super(router, route, dataService, appDataService, responseParserService, dialogService, spinnerService, errorService);
  }

  ngOnInit(): void {
    this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsApplicationNonMainsWaterConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.concessionsApplicationNonMainsWater.save;

    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        const personId = paramMap.get('personId');
      
        if (id) {
          this.id = id;
          this.editing = true;
        } else if (personId) {
          this.id = `${Guid.EMPTY}/${personId}`
          this.personId = personId;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      isPrimaryAddressManual: () => this.isPrimaryAddressManual(),
      isPrimaryAddressAuto: () => this.isPrimaryAddressAuto(),
      showCenterlinkCardDetails: () => this.showCenterlinkCardDetails(),
      showVeteransAffairsCardDetails: () => this.showVeteransAffairsCardDetails(),
      showPensionerCardIssuer: () => this.showPensionerCardIssuer(),
      exit: () => this.exit(),
      true: () => true,
      false: () => false,
      readOnly: () => true,
      showStatDecUpload: () => this.showStatDecUpload(),
      showInvoiceUpload: () => this.showInvoiceUpload(),
      isConsentNotAgree: () => this.isConsentNotAgree(),
      isConsentAgree: () => this.isConsentAgree(),
      isConsentNotsignedandNoConfirmation: () => this.isConsentNotsignedandNoConfirmation(),
      showSignedApplicationUpload: () => this.showSignedApplicationUpload(),
      isCustomerPortalApplication: () => this.isCustomerPortalApplication(),
      isStaffPortalApplication: () => this.isStaffPortalApplication(),
      addNewPostalAddress: () => this.addNewPostalAddress(),
      isReadOnly: () => this.isReadOnly(),
      isEditOrStaffPortalApplication: () => true,
      isFirstNameReadonly: () => this.isFirstNameReadonly(),
      isLastNameReadonly: () => this.isLastNameReadonly(),
      isEmailReadonly: () => this.isEmailReadonly(),
      isMobilePhoneReadonly: () => this.isMobilePhoneReadonly(),
      isOtherPhoneReadonly: () => this.isOtherPhoneReadonly(),
      isDateOfBirthReadonly: () => this.isDateOfBirthReadonly(),
      isPrimaryAddressReadonly: () => this.isPrimaryAddressReadonly(),
      isPostalAddressSameAsPrimaryAddressReadonly: () => this.isPostalAddressSameAsPrimaryAddressReadonly(),
      isPostalAddressReadonly: () => this.isPostalAddressReadonly()
    }

    this.coreService.applicationFunctions = {
      exit: () => this.exit(),
      showInvoiceSectionHelp: () => this.showInvoiceSectionHelp(),
      fileUploadOnBeforeRemove: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoice(file, onComplete)
    }

    this.coreService.repeatingSectionFunctions = {
      onSaveInvoice: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoice(itemIndex, onComplete),
      onBeforeRemoveInvoice: (itemIndex, callback) => this.onBeforeRemoveInvoice(itemIndex, callback),
    };

    this.registerSaveOnNavigation();
  }

  fileUploadOnBeforeRemoveInvoice(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab4?.page1?.invoiceInfo;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocument === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortal) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.formNavSubscription.unsubscribe();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    super.formLoad($event);
    this.activeApplications = $event.activateApplications;
    this.concessionsPaymentRules = $event.concessionsPaymentRules;
    this.previousInvoiceNumbers = $event.previousInvoiceNumbers;
    this.amountPaidByApplicationYear = $event.amountPaidByApplicationYear;
    this.previousApplications = $event.previousApplications;
    this.formHeaderModel = $event.headerResponse;
    this.isPersonBothCarerAndConcessionsApplicant = $event.isPersonBothCarerAndConcessionsApplicant;
    this.isPersonWithActiveCareAllowancePlacements = $event.isPersonWithActiveCareAllowancePlacements;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.invoiceDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.entitlementLetter] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.signedApplication] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.patientUploadDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.statDecDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
  }

  home(event: any) {
    this.navigateBackToHome();
  }

  exit() {
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }

   if (event.isSubmit) {
      if (event.isFormValid === false) {
        this.baseForm.markAllFieldsAsTouched();
        this.baseForm.showValidationSummary(true);
      }
      else {
        // submit application
        this.saveData(saveDataRequest);
      }
    }
    else {
      if (this.formNavigationService.canNavigateNext()) {
        this.saveData(saveDataRequest);
      }
    }
  }

  cancel(event: any) {
    if (this.formNavigationService.currentTabIndex == 0 && this.formNavigationService.currentPageIndex == 0) {
      this.navigateToConcessionsInfo();
    } else {
      this.formNavigationService.moveBack();
    }
  }

  buttonClick(event: any): void {
  }

  actionButtonClick(event: any): void {
  }

  dialogSubmit(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.concessionsApplicationCommon.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
    }
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {
      var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      if (addressSection) {
        var value = addressSection[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.primaryAddressManualAddress];
        this.primaryAddressIsManual = (value === true);
      }

      this.UpdateHeaderAndApplicationPeriod();
    }
  }

  private UpdateHeaderAndApplicationPeriod() {
    let applicationPeriod = this.updateHeaderSubtitle(this.baseForm.optionSets.financialyear as Option[]);
    if (applicationPeriod) {
      this.baseForm.model.form.tabs.tab4.page1.invoiceUpload.applicationPeriod = applicationPeriod;
    }
  }

  isPrimaryAddressManual(): boolean {
    return this.primaryAddressIsManual;
  }

  isPrimaryAddressAuto(): boolean {
    return !this.primaryAddressIsManual;
  }

  showCenterlinkCardDetails(): boolean {
    //only displays if Card Type == 'Pensioner Concession Card' AND Pensioner Card Issuer = 'Centrelink' (selected as the issuer)
    //Or Card Type == 'Health Care Card'
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;

    let result = cardType === OPTION_SETS.concessionsCardType.options.healthCareCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.centrelink);

    var centrelinkCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.centrelinkCardNumber;

    if (result === true && !centrelinkCardNumber) {
      // setting the Centrelink Card Number
      let profileCentrelinkCardNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileCentrelinkCardNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsWaterForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsWaterForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsWaterForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsWaterForm.centrelinkCardNumber],
        profileCentrelinkCardNumber);
    }

    return result;
  }

  showVeteransAffairsCardDetails(): boolean {
    //only displays if 'Pensioner Concession Card' AND 'Veterans Affairs' (selected as the issuer)
    //OR 'Veterans Affairs Gold Card' selected on above question
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;

    let result = cardType === OPTION_SETS.concessionsCardType.options.veteransAffairsGoldCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.veteransAffairs);

    let veteransAffairsCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.veteransAffairsCardNumber;

    if (result === true && !veteransAffairsCardNumber) {
      // setting the Veterans Affairs File Number
      let profileVeteransAffairsFileNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileVeteransAffairsFileNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsWaterForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsWaterForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsWaterForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsWaterForm.veteransAffairsCardNumber],
        profileVeteransAffairsFileNumber);
    }

    return result;
  }

  showPensionerCardIssuer(): boolean {
    return (this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard);
  }

  

  private registerSaveOnNavigation() {
    this.formNavSubscription =
      this.formNavigationService.onNavigation()
        .pipe(
          bufferTime(200),
          filter(x => x.length > 0)
        ).subscribe(async (data) => {
          this.viewportScroller.scrollToPosition([0, 0]); //Always navigate to the top of the page

          let tabNumber = data.find(x => x.elementType === ElementType.TAB)?.elementNumber
          let pageNumber = data.find(x => x.elementType === ElementType.PAGE)?.elementNumber

          if (this.coreService.isFormEditable === true) {
            // If the user is navigating forwards
            if (tabNumber > this._currentTab || pageNumber > this._currentPage) {
              //introduction confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsWaterForm.intro
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsWaterForm.intro) {

                if (!this.selectedApplyForYear) {
                  this.UpdateHeaderAndApplicationPeriod();
                }

                if (this.activeApplications) {
                  // check if there is active application for selected year
                  const selectedApplicationYearApplicationsCount = this.activeApplications
                    .filter(item => item.applicationYear === this.selectedApplyForYear)
                    .map(item => item.count)
                    .find(count => count !== undefined);

                  if (selectedApplicationYearApplicationsCount != null && selectedApplicationYearApplicationsCount > 0) {
                    this.activeDialog = POP_UP_CODES.concessionsApplicationCommon.applicationInProgress;
                    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.applicationInProgress, null, { applicationYear: this.applicationPeriod }, false);

                    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                    return;
                  }
                }
              }

              //check address is in victoria
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsWaterForm.applicant
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsWaterForm.applicant) {
                const addressInVic = this.isAddressInVictoria(this.baseForm.model.form.tabs.tab2.page1.address, QUESTION_CODES.concessionsApplicationNonMainsWaterForm.primaryAddress)
                if (!addressInVic) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invalidResidentialAddress);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }
              }

              //Invoice confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsWaterForm.invoice
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsWaterForm.invoice) {
                const invoicePage = this.baseForm.model.form.tabs.tab4.page1;
                if (!this.checkSupportingDocCheckboxSelectedOnInvoice(invoicePage.documentInfo)) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsWaterForm.checkSupportingDocValidation);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }

                // The user is attempting to navigate away from the invoice page
                // If any of invoice section are expanded, then we want to prevent navigation forwards, and show
                // a popup telling the user they must save their invoice before proceeding.
                const isAnyInvoiceInEditMode = this.checkIfAnyInvoiceIsInEditMode(invoicePage.invoiceInfo);

                if (isAnyInvoiceInEditMode) {
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);

                  // Show a dialog.
                  this.dialogService.showSimplePopup(POP_UP_TEXTS.common.saveInvoice, POP_UP_HEADER.common.saveInvoice);
                  return;
                }
              }

              // This condition added to avoid calling backend API more than once
              // on component initialization.
              if (this._previousPage !== this._currentPage || this._previousTab !== this._currentTab) {
                this._previousTab = this._currentTab;
                this._previousPage = this._currentPage;
                if (this.isDraftApplication) {
                  this.saveOnNavigation(this.templateId, this.versionNo);
                }
              }
            }
          }

          this._currentTab = tabNumber ?? this._currentTab;
          this._currentPage = pageNumber ?? this._currentTab;
        });
  }

  private findClosestPaymentAmount(value, data) {
    let closestLine = null;
    let closestDifference = Infinity;

    for (const entry of data) {
      const difference = entry.maxThresholdAmounts - value;
      if (difference >= 0 && difference < closestDifference) {
        closestDifference = difference;
        closestLine = entry;
      }
    }
    return closestLine;
  }

  private onSaveInvoice(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    //check date of invoice
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab4?.page1?.invoiceInfo;
    const invoiceSelected = invoiceInfo[itemIndex];
    
      const invoiceDate = this.parseDateString(invoiceSelected.invoiceDate);
      const applicationPeriodDates = this.baseForm.model.form.tabs.tab4.page1.invoiceUpload.applicationPeriod.split(' to ');
      const fromDate = new Date(applicationPeriodDates[0]);
      const toDate = new Date(applicationPeriodDates[1]);
     // add 30 days to toDate
      toDate.setDate(toDate.getDate() + 30);
      const invoiceDateOk = invoiceDate >= fromDate && invoiceDate <= toDate;

      if (invoiceDateOk) {
        // add the total of invoices
        let invoiceTotal: number = 0;
        invoiceInfo.forEach(item => {
          invoiceTotal = invoiceTotal + parseFloat(item.invoiceAmount);
        });

        this.baseForm.model.form.tabs.tab4.page1.invoiceUpload.invoiceTotal = "$" + invoiceTotal.toFixed(2);
        const fileName = this.extractFileName(invoiceInfo[itemIndex].invoiceDocument);
        invoiceSelected.filename = fileName;
        invoiceSelected.invoiceAmount = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected.invoiceAmount);
        onComplete(false);
      } else {
        this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsWaterForm.invoiceDateValidation);
        onComplete(true);
      }
  }

  private onBeforeRemoveInvoice(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab4?.page1?.invoiceInfo;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortal === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {     
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsWaterForm.invoiceAmount;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab4.page1.invoiceUpload.invoiceTotal = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  showStatDecUpload(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab4?.page1?.invoiceUpload?.documentType;
    if (docType) {
      return (docType === OPTION_SETS.concessionsDocType.options.statutorydeclaration);
    }
    return false;
  }

  showInvoiceUpload(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab4?.page1?.invoiceUpload?.documentType;
    if (docType) {
      const isInvoice = (docType === OPTION_SETS.concessionsDocType.options.invoice);
      if (isInvoice === true) {
        this.baseForm.model.form.tabs.tab4.page1.invoiceUpload.applicationPeriod = this.applicationPeriod;
      }
      return isInvoice;
    }
    return false;
  }
}
